import { vuexTypes } from '../types'
import { RecordFactory } from '@js/records/factory'
import { giftMallService } from '@api/giftmall.service'

const state = {
  gift_mall_config: {
    organizations: [],
    recipient: ''
  },
  pre_order: null
}

export const mutations = {
  SET_GIFTMALL_CONFIG: (state, config) => {
    state.gift_mall_config = config
  },
  SET_GIFTMALL_PRE_ORDER: (state, preOrder) => {
    state.pre_order = preOrder
  }
}

export const actions = {
  async GET_GIFTMALL_CONFIG ({ commit }) {
    const data = await giftMallService.loadGiftMallConfig()
    const config = RecordFactory.createGiftMallConfigRecord(data)
    config.organizations = config
      .organizations
      .map(organization => RecordFactory.createGiftMallOrganisationRecord(organization))
    commit(vuexTypes.SET_GIFTMALL_CONFIG, config)
  },
  /**
   * Order up the gift certificate
   *
   * @param commit
   * @param $opts
   *  $certificate_value
   *  $organization_id
   *  $address
   * @return {ResponseBuilder}
   */
  async GET_GIFTMALL_PRE_ORDER ({ commit }, $opts) {
    const data = await giftMallService.preOrder($opts)
    commit(vuexTypes.SET_GIFTMALL_PRE_ORDER, data)
  }
}

export const getters = {
  giftMallConfig: state => state.gift_mall_config,
  giftMallPreOrder: state => state.pre_order
}

export default {
  actions,
  getters,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/giftmall.module.js